import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/img/Mensajeiniciovalidacion.png'
import _imports_1 from '../assets/img/Warning.png'


const _hoisted_1 = { class: "LoadFile" }
const _hoisted_2 = {
  key: 0,
  class: "col-full",
  style: {"text-align":"right","padding-top":"3em"}
}
const _hoisted_3 = { class: "col-full" }
const _hoisted_4 = {
  key: 0,
  class: "PopUpVideo_video"
}
const _hoisted_5 = {
  id: "video",
  class: "PopUpVideo_video_player",
  controls: "",
  ref: "videoIndividual"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "p-dialog-header-close-icon pi pi-times" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "PopUpVideo_video"
}
const _hoisted_10 = {
  id: "video",
  class: "PopUpVideo_video_player",
  controls: "",
  ref: "videoAjuste"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "p-dialog-header-close-icon pi pi-times" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "col-full" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "LoadFile_containerSubtitle" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "LoadFile_containerSubtitle_subtitle" }, " Selección Transmisión de Nómina Electrónica ")
], -1)
const _hoisted_17 = { class: "cuerpo" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "txtG" }, " Selecciona el mes y año correspondiente al periodo de Nómina que deseas cargar: ", -1)
const _hoisted_19 = {
  class: "row mgb0 pl3",
  style: {"padding-left":"28%"}
}
const _hoisted_20 = { class: "col-md-6 w5" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "txtG" }, "Año", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = ["label", "value"]
const _hoisted_24 = { class: "col-md-6 w5" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "txtG" }, "Mes", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = ["label", "value"]
const _hoisted_28 = { class: "cuerpo" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h3", null, "Plantillas disponibles", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "align" }, " A continuación encontrarás la plantilla que te permitirá cargar en el sistema la información para la Transmisión de la Nómina Electrónica. ", -1)
const _hoisted_32 = ["for"]
const _hoisted_33 = ["id", "accept"]
const _hoisted_34 = { class: "custom-file-upload" }
const _hoisted_35 = {
  key: 0,
  class: "selected-file"
}
const _hoisted_36 = { class: "file-name" }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col-full" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("strong", { class: "lbldownload" }, "Tipo de Validación:"),
    /*#__PURE__*/_createElementVNode("span", { class: "txtG" }, "Validar y completar según instructivo")
  ])
], -1)
const _hoisted_39 = { class: "col-full" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "col-full pr" }
const _hoisted_42 = { class: "lbldownload" }
const _hoisted_43 = { class: "LoadFile_modal" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("img", {
  class: "LoadFile_modal_image",
  alt: "Mensaje Validacion",
  src: _imports_0
}, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "60",
  height: "60",
  alt: "Alerta"
}, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "80",
  height: "80",
  style: {"margin-right":"25px"},
  alt: "Alerta"
}, null, -1)
const _hoisted_47 = {
  class: "gray-text",
  style: {"text-align":"justify"}
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_center = _resolveComponent("center")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_PopUpConfirmarTransmision = _resolveComponent("PopUpConfirmarTransmision")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      ($setup.pbi232826)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "btnPopUp btnLandPostPopUp",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.visiblePopUpBotones = true))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'play-circle'],
                size: "sm"
              }),
              _createTextVNode(" Mira cómo se hace ")
            ]),
            _createVNode(_component_el_dialog, {
              title: "Selecciona el video tutorial que deseas visualizar",
              modelValue: $setup.visiblePopUpBotones,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.visiblePopUpBotones) = $event)),
              width: "30%",
              center: ""
            }, {
              footer: _withCtx(() => [
                _createElementVNode("input", {
                  type: "button",
                  value: "Volver",
                  class: "btnPopUpAjuste btnLandPostPopUpAjuste",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.visiblePopUpBotones = false))
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("input", {
                    type: "button",
                    value: "Transmitir nómina\r\nindividual",
                    class: "btnPopUpIndividual btnLandPostPopUpIndividual",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.visiblePopUpIndividual = true, $setup.visiblePopUpBotones = false))
                  }),
                  _createVNode(_component_Dialog, {
                    visible: $setup.visiblePopUpIndividual,
                    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (($setup.visiblePopUpIndividual) = $event)),
                    width: "50%",
                    higth: "50%",
                    center: "",
                    closable: false
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "p-dialog-header-icon p-dialog-header-close p-link",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.detenerVideo('videoIndividual'))),
                        style: {"margin-left":"95%"}
                      }, _hoisted_8)
                    ]),
                    default: _withCtx(() => [
                      ($setup.urlvdIndividual != '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("video", _hoisted_5, [
                              _createElementVNode("source", {
                                src: $setup.urlvdIndividual,
                                type: "video/mp4"
                              }, null, 8, _hoisted_6)
                            ], 512)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["visible"]),
                  _createElementVNode("input", {
                    type: "button",
                    value: "Transmitir nómina\r\n      de ajuste",
                    class: "btnPopUpAjuste btnLandPostPopUpAjuste",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.visiblePopUpAjuste = true, $setup.visiblePopUpBotones = false))
                  }),
                  _createVNode(_component_Dialog, {
                    visible: $setup.visiblePopUpAjuste,
                    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (($setup.visiblePopUpAjuste) = $event)),
                    width: "50%",
                    higth: "50%",
                    center: "",
                    closable: false
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "p-dialog-header-icon p-dialog-header-close p-link",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.detenerVideo('videoAjuste'))),
                        style: {"margin-left":"95%"}
                      }, _hoisted_13)
                    ]),
                    default: _withCtx(() => [
                      ($setup.urlvdAjuste != '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("video", _hoisted_10, [
                              _createElementVNode("source", {
                                src: $setup.urlvdAjuste,
                                type: "video/mp4"
                              }, null, 8, _hoisted_11)
                            ], 512)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["visible"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("input", {
              type: "button",
              value: "Instructivo",
              class: "btnDownL btnLandPostDown",
              onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.Download('InstructivoCargueNominaElectronica.pdf')))
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("input", {
                type: "button",
                value: "Instructivo",
                class: "Button_BColorDegraded btnInstructivoElse",
                onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.Download('InstructivoCargueNominaElectronica.pdf')))
              })
            ])
          ])),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("form", null, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _hoisted_22,
              _withDirectives(_createElementVNode("select", {
                class: "select_anio",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.year) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.anios, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: item.parametricasNEId,
                    label: item.valor,
                    value: item.valor
                  }, null, 8, _hoisted_23))
                }), 128))
              ], 512), [
                [_vModelSelect, $setup.year]
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _hoisted_26,
              _withDirectives(_createElementVNode("select", {
                class: "select_mes",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.month) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.meses, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, _hoisted_27))
                }), 128))
              ], 512), [
                [_vModelSelect, $setup.month]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_component_font_awesome_icon, {
                class: "icon-float",
                icon: ['fas', 'exclamation-circle'],
                color: "#fd7e14",
                size: "3x",
                position: "top-right"
              }),
              _hoisted_31,
              _createElementVNode("h3", null, [
                _createElementVNode("a", {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.Download('Plantilla.xlsx'))),
                  class: "lbldownload underline"
                }, "Nueva Plantilla: Descargar")
              ])
            ]),
            _createVNode(_component_center, null, {
              default: _withCtx(() => [
                _createElementVNode("label", {
                  for: $setup.inputId,
                  class: "btnDownL btnLandPostDown",
                  style: {"margin-left":"0"}
                }, "Cargar archivo", 8, _hoisted_32),
                _createElementVNode("input", {
                  type: "file",
                  id: $setup.inputId,
                  accept: $setup.accept,
                  ref: "fileInput",
                  onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => ($setup.onFileChange && $setup.onFileChange(...args))),
                  style: {"display":"none"}
                }, null, 40, _hoisted_33),
                _createElementVNode("div", _hoisted_34, [
                  ($setup.file)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("span", _hoisted_36, _toDisplayString($setup.file.name), 1),
                        _createElementVNode("a", {
                          class: "file-name",
                          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => ($setup.clearFile && $setup.clearFile(...args)))
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: ['fas', 'times'],
                            size: "lg"
                          })
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("p", null, _toDisplayString($setup.fileMessage), 1)
                      ]))
                ])
              ]),
              _: 1
            }),
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("input", {
                type: "button",
                id: "question-pro-validar",
                onClick: [
                  _cache[16] || (_cache[16] = ($event: any) => ($setup.ValidarCamposDeEntrada())),
                  _cache[17] || (_cache[17] = ($event: any) => ($setup.messageValidation()))
                ],
                value: "Validar",
                style: {"margin-left":"0"},
                class: "btnDownL btnLandPostDown",
                disabled: $setup.buttonStatus
              }, null, 8, _hoisted_40),
              _createElementVNode("input", {
                type: "button",
                onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.GoTransmission())),
                value: "Cancelar",
                class: "btnDownL btnLandPostDown"
              })
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("strong", _hoisted_42, _toDisplayString($setup.message), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      "show-close": false,
      modelValue: $setup.ValidationVisible,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.ValidationVisible) = $event)),
      width: "63%",
      center: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("a", {
            class: "Button_BGrayButton",
            id: "question-pro-aceptar",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (($setup.dialogVisible = false), $setup.ConfirmarNotificacionFinalizacion()))
          }, "Aceptar")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_Dialog, {
      visible: $setup.dialogVisible,
      "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => (($setup.dialogVisible) = $event)),
      modal: "",
      closable: false,
      header: $setup.errorModalTitle,
      draggable: false,
      id: "p-dialog",
      class: "error-dialog"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.dialogVisible = false)),
          text: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("← Volver")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _hoisted_45,
        _createElementVNode("p", null, _toDisplayString($setup.messageError), 1)
      ]),
      _: 1
    }, 8, ["visible", "header"]),
    _createVNode(_component_ConfirmDialog, {
      id: "confirm-dialog",
      class: "confirm-modal",
      draggable: false
    }, {
      message: _withCtx((props) => [
        _hoisted_46,
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_47, [
            _createTextVNode(_toDisplayString(props.message.message) + " ", 1),
            _hoisted_48,
            _hoisted_49
          ])
        ])
      ]),
      _: 1
    }),
    ($setup.mostrarPopUpConfirmarTransmision)
      ? (_openBlock(), _createBlock(_component_PopUpConfirmarTransmision, {
          key: 0,
          UploadFile: $setup.UploadFile,
          year: $setup.year,
          month: $setup.month
        }, null, 8, ["UploadFile", "year", "month"]))
      : _createCommentVNode("", true),
    ($setup.loading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 1,
          type: "modern"
        }))
      : _createCommentVNode("", true)
  ], 64))
}